module.exports = __webpack_public_path__ + "media/images/area_1-b0b307749a6ce583ee1e66d00ec2821d.png";